export
default {
        common:
        {
            langEn: 'English',     
            langZh: '简体中文',       
            langFt: '繁體中文',      
            langMl: 'Bahasa Melayu', 
            langYn: 'Tiếng Việt',   
            langJa: '日本語',         
            langKr: '한국어',       
            langFa: 'Français',    
            langTr: 'Türkçe',     
            langYin: 'Bahasa Indonesia', 
            langEs: 'Español'   
        },

        home: {
            h1: "Criptomoneda MetaMask",
            h1B: "Banco de Criptomonedas MetaMask",
            h1C: "Criptomoneda DeFi Wallet",
            h1D: "Banco de Criptomonedas Coinbase",
            h1E: "Banco de Ahorros MetaMask",
            h1F: "Betterment",
            h2: "Invitar Amigos",
            h3: "Vincular Cuenta de Retiro",
            h4: "Participar en Ahorros",
            h4B: "Depósito en Criptomonedas",
            h4C: "Recarga de Moneda Digital",
            h5: "Finanzas Destacadas",
            h5B: "Operaciones de Contrato Rápido",
            h5c: "Depositar",
            h6: "Pool de Usuarios",
            h7: "Cuenta USDT",
            h8: "Producción Total",
            h9: "Nodos Válidos",
            h10: "Participantes",
            h11: "Ganancias",
            h12: "Historial de Ganancias",
            h13: "Dirección",
            h14: "Número",
            h15: "Preguntas Frecuentes",
            h16: "¿Cómo participar?",
            h17: "Estimado usuario, si desea participar en los ahorros de la billetera USDT, debe cumplir con las reglas de la plataforma, acatar estrictamente las decisiones de la misma, aceptar la supervisión del departamento de riesgos y obtendrá automáticamente el permiso de depósito. Bienvenido y gracias por participar.",
            h17B: "Estimado usuario, si desea participar en los ahorros de la billetera USDT, debe cumplir con las reglas de la plataforma, acatar estrictamente las decisiones de la misma, aceptar la supervisión del departamento de riesgos y obtendrá automáticamente el permiso de depósito. Bienvenido y gracias por participar.",
            h18: "¿Cómo retirar?",
            h19: "Las ganancias generadas diariamente se acreditarán automáticamente en el saldo de su cuenta. Una vez completado el retiro en USDT, se añadirá a su billetera USDT. Si necesita retirar en yenes, por favor contacte al centro de servicio al cliente. Gracias por su participación y apoyo.",
            h19B: "Las ganancias generadas diariamente se acreditarán automáticamente en el saldo de su cuenta. Una vez completado el retiro en USDT, se añadirá a su billetera USDT. Para otros métodos de retiro, consulte con el servicio de atención al cliente en línea.",
            h20: "¿Cómo se calcula el ingreso?",
            h21B: "Compra por ciclos, las ganancias varían según el nivel VIP\nVIP1  100u~5000u, tasa: 1.8%\nVIP2  5000u~20000u, tasa: 2.6%\nVIP3  20000u~50000u, tasa: 3.5%\nVIP4  50000u~80000u, tasa: 4.7%\nVIP5  80000u~120000u, tasa: 5.3%\nVIP6  120000u~160000u, tasa: 6.2%\nVIP7  160000u~200000u, tasa: 7.3%\nVIP8  Más de 200000u, tasa: 8%\n\n",
            h21: "Después de unirse con éxito, el contrato de ahorro comenzará a calcular las ganancias.",
            h22: "¿De dónde provienen las ganancias de los ahorros?",
            h23: "Después de que los usuarios participen en ahorros, el contrato de ahorro entra en vigor. Los intereses se liquidan dos veces al día a las 00:00 y a las 12:00. Una vez activo, los fondos entran en modo de custodia y la plataforma es responsable de la seguridad. Para proteger los fondos de su cuenta, siga estrictamente las reglas de la plataforma. En caso de problemas, contacte al servicio en línea.",
            h23B: "Después de que los usuarios participen en ahorros, el contrato de ahorro entra en vigor. Los intereses se liquidan dos veces al día a las 00:00 y a las 12:00. Una vez activo, los fondos entran en modo de custodia y la plataforma es responsable de la seguridad. Para proteger los fondos de su cuenta, siga estrictamente las reglas de la plataforma. En caso de problemas, contacte al servicio en línea.",
            h24: "¿Cuánto es el bono?",
            h25: "Puede compartir mi plataforma con amigos. Cuando sus amigos participen, obtendrá el 20% de su primer depósito como bono de recomendación y de forma permanente el 10% de sus ganancias como comisión. El enlace público para compartir está en la esquina superior derecha de la página principal.",
            h25B: "Puede compartir esta plataforma con amigos. Cuando sus amigos participen, obtendrá el 20% de su primer depósito como bono de recomendación y de forma permanente el 10% de sus ganancias como comisión. El enlace para compartir está en la esquina superior derecha de la página principal.",
            h26: "Saldo Disponible",
            h27: "Monto de Depósito",
        
            h88: "Antecedentes de la Plataforma",
            h89: "Betterment\nFundación: 2008\nSede: Nueva York, EE.UU.\nPosicionamiento: Robo-Advisor y FinTech, ofrece carteras de inversión automatizadas y gestión de efectivo\nRegulación: Supervisado por la SEC, miembro de FINRA\nClientes: Más de 40 mil millones USD en activos bajo gestión\nBase de clientes: Más de 800,000 clientes individuales y corporativos",
            h90: "Ventajas de la Plataforma",
            h91: "✔️ Uno de los primeros Robo-Advisors en EE.UU., con experiencia\n✔️ Carteras basadas en la Teoría Moderna de Portafolios (MPT), diversificación de riesgos\n✔️ Funciones de optimización fiscal\n✔️ Cuentas en efectivo de alto interés, gran liquidez\n✔️ Operaciones completamente digitales, interfaz sencilla",
            h92: "Público Objetivo",
            h93: "★ Usuarios que buscan inversiones estables a largo plazo sin operaciones frecuentes\n★ Jóvenes inversores que necesitan gestión financiera automatizada para ahorrar tiempo y esfuerzo\n★ Personas que combinan inversión + ahorro de alto interés + cuentas de jubilación\n★ Inversores comunes que desean ingresar al mercado financiero a bajo costo",
        
            h28: "Ganancias de Hoy",
            h29: "Ganancias Totales",
            h30: "Retirar",
            h31: "Registros",
            h32: "Saldo Disponible",
            h33: "Monto de Retiro",
            h34: "Por favor, ingrese el monto de retiro",
            h35: "Todo",
            h36: "Retirar",
            h37: "Preguntas Frecuentes",
            h38: "Informe de Auditoría de Seguridad",
            h39: "Socios",
            h40: "Nuestros Socios Comerciales",
            h41: "Mostrar Número de Tarjeta Bancaria",
            h42: "Página Anterior",
            h43: "Página Siguiente",
            h44: "Ya está en la primera página",
            h45: "Por favor, ingrese el monto de retiro",
            h46: "Saldo Insuficiente",
            h47: "Ya está en la última página",
            h48: "Ingresos",
            h49: "Gastos",
            h50: "Operaciones demasiado frecuentes, inténtelo más tarde.",
            h51: "Informe de Auditoría",
            h52: "Ahorros en Criptomonedas",
            h521: "Ahorros con Depósitos",
            h53: "Operaciones de Orden",
            h54: "Bono de Registro",
            h55: "Bono de Invitación",
            h56: "Retirar",
            h57: "Recargar",
            h58: "Depositar",
            h59: "Retiro",
            h591: "Depósito Exitoso",
            h592: "Depósito Fallido",
            h593: "Saldo Insuficiente",
            h60: "Regalar USDT a través de Transferencia en Criptomonedas",
            h61: "Gracias a los usuarios por apoyar al Banco MetaMask. Para facilitar los ahorros, los depósitos mediante criptomonedas (USDT, ETH, BTC) recibirán recompensas. Deposite más de 1000 USDT y obtenga 30 USDT, más de 5000 USDT obtenga 200 USDT, más de 10000 USDT obtenga un 5% adicional en cada depósito. (Los retiros mediante billetera cripto también disfrutan de este beneficio)",
            h61B: "Gracias a los usuarios por apoyar al Banco Coinbase. Para facilitar los ahorros, los depósitos mediante criptomonedas (USDT, ETH, BTC) recibirán recompensas. Deposite más de 1000 USDT y obtenga 30 USDT, más de 5000 USDT obtenga 200 USDT, más de 10000 USDT obtenga un 5% adicional en cada depósito.",
            h61C: "Gracias a los usuarios por apoyar al Banco MetaMask. Para facilitar los ahorros, los depósitos mediante criptomonedas (USDT, ETH, BTC) recibirán recompensas. Deposite más de 1000 USDT y obtenga 30 USDT, más de 5000 USDT obtenga 200 USDT, más de 10000 USDT obtenga un 5% adicional en cada depósito.",
            h61D: "Gracias a los usuarios por apoyar a Betterment. Para facilitar los ahorros, los depósitos mediante criptomonedas (USDT, ETH, BTC) recibirán recompensas. Deposite más de 1000 USDT y obtenga 30 USDT, más de 5000 USDT obtenga 200 USDT, más de 10000 USDT obtenga un 5% adicional en cada depósito.",
            h62: "Su monto de retiro es {amount}, la comisión es {fee}%!",
            h63: "Confirmar",
            h99: "Próximamente",
        },
        bankcard: {
            b1: "Cuenta Bancaria",
            b2: "Nombre de la Institución Financiera",
            b3: "Por favor, ingrese el nombre de la institución financiera",
            b4: "Nombre de la Sucursal",
            b5: "Por favor, ingrese el nombre de la sucursal",
            b6: "Número de Sucursal",
            b7: "Por favor, ingrese el número de la sucursal",
            b8: "Cuenta (Ordinaria)",
            b9: "Por favor, ingrese el número de cuenta",
            b10: "Kana",
            b11: "Por favor, ingrese el nombre de usuario",
            b12: "Titular de la Cuenta",
            b13: "Por favor, ingrese el nombre del titular",
            b14: "Vincular",
            b15: "Dirección de Criptomoneda",
            b16: "Por favor, ingrese la dirección de criptomoneda",
        },
        usdt: {
            u1: "Mis Órdenes",
            u2: "Depositar",
            u3: "Por favor seleccione el tiempo del contrato:",
            u4: "Precio de Compra:",
            u5: "Por favor, ingrese el monto del depósito",
            u6: "Aumentar Compra",
            u7: "Disminuir Compra",
            u8: "Operación Exitosa",
            u9: "Al menos un punto"
        },
        order: {
            o0: "Mis Órdenes",
            o1: "Número de Orden",
            o2: "Tipo de Orden",
            o3: "Monto de Compra",
            o4: "Monto de Venta",
            o5: "Monto de Pago",
            o6: "Tiempo de Contrato",
            o7: "Estado de la Orden",
            o8: "Estado de Liquidación",
            o9: "Hora de Liquidación",
            o10: "Hora de la Orden",
            o11: "Aumentar Compra",
            o12: "Disminuir Compra",
            o13: "Vendido",
            o14: "Ganancia",
            o15: "Pérdida",
            o16: "Pagado",
            o17: "Punto de Equilibrio"
        },
        recharge: {
            r1: "Monto de Recarga",
            r2: "Valor de Recarga",
            r3: "Tipo de Recarga",
            r4: "Por Favor Seleccione",
            r5: "Dirección de Recarga",
            r6: "Número de Transacción de Transferencia",
            r7: "Transferido",
            r8: "En Revisión",
            r9: "Entrada Incorrecta",
            r10: "Por Favor Seleccione el Método de Pago",
            r11: "El Monto Mínimo de Recarga es",
            r12: "El Monto Máximo de Recarga es",
            r13: "Por Favor Ingrese el Monto",
            r14: "Subir Captura del Pago",
            r15: "Por Favor Suba la Captura del Pago",
            r16: "Enviado Exitosamente",
            r17: "Cancelar",
            r18: "Confirmar",
        },
        rechargeDetails: {
            r1: "Registros de Recarga",
            r2: "Monto de Recarga",
            r3: "En Revisión",
            r4: "Recarga Exitosa",
            r5: "Recarga Fallida"
        },
		cert: {
		    c1: "Verificación de identidad",
		    c2: "Nombre real",
		    c21: "Por favor, ingrese su nombre real",
		    c3: "Tipo de documento",
		    c31: "Documento de identidad",
		    c32: "Pasaporte",
		    c33: "Licencia de conducir",
		    c10: "Ingrese el tipo de documento",
		    c4: "Anverso del documento",
		    c41: "Por favor, cargue el anverso del documento",
		    c5: "Reverso del documento",
		    c51: "Por favor, cargue el reverso del documento",
		    c6: "Enviar",
		    c7: "Enviado correctamente, en espera de revisión...",
		    c8: "Verificación aprobada",
		    c9: "La verificación de identidad no fue aprobada, por favor vuelva a subir los documentos",
		    c11: "En revisión",
		    "传入字段不完整": "Faltan campos requeridos",
		    "已认证过": "Ya ha sido verificado",
		    "审核中": "En revisión"
		}
		 }